//#region ImportSection
import "bootstrap/dist/css/bootstrap.min.css";

import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { GetLanguageString } from "../helper/Components";
import {
  FaEllipsisV,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPencilAlt,
  FaGraduationCap,
  FaBriefcase,
  FaRegComment,
  FaExchangeAlt,
  FaUserPlus,
  FaComments,
  FaPeopleArrows,
} from "react-icons/fa";

import {
  applyClassToCharacters,
  CheckIsAdmin,
  CheckPermission,
  getStringFromJSX,
  isUrdu,
} from "../../constants/const";
import AhbabProgressBar from "./AhbabProgressBar";
import { GetCustomStyles } from "../helper/Method";
import { encryptData } from "../../constants/EncryptData";
import { encryptStorage } from "../../constants/EncryptStorage";

//#endregion ImportSection

//#region StyleSection
const Container = styled.div`
  padding: 20px;
  border-radius: 12px;
  color: #000;
  background-color: ${(props) => bgColorChange(props)};
  min-height: 350px;
  max-height: 350px;

  margin-bottom: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0px;
  transition: all 0.25s ease-in-out;
  border: 1px solid #e0e0e0;

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
    transform: translateY(-5px);
  }
`;

function bgColorChange(props) {
  return props.isdraggingover
    ? "white"
    : props.isDraggable
    ? props.isBacklog
      ? "yellow"
      : "white" //"#1ab394"
    : props.isBacklog
    ? "yellow"
    : "white";
}
function panelColorChange(props) {
  if (props.isdraggingover) return "panel panel-danger";
  if (props.isDraggable)
    return props.isBacklog ? "panel panel-danger" : "panel panel-success";
  return props.isBacklog ? "panel panel-success" : "panel panel-default";
}
//#endregion StyleSection
const styles = `
    .show-on-top {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  
  transform-origin: bottom left;          
  z-index: 1050 !important;
}
    `;
const HabibProgressCard = ({
  task,
  index,
  onComment,
  onUpdateNisabClick,
  onUpdateAssociateMemberClick,
  onMoveMemberClick,
  viewComments,
  progress,
  onchangestatus,
}) => {
  //#region stateSection

  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const [subOpen, setSubOpen] = useState(false);
  //#endregion stateSection

  return (
    <>
      <style>{styles}</style>
      <>
        <Draggable
          draggableId={`${task.id}`}
          habibId={`${task.habibId}`}
          key={task.id}
          index={index}
        >
          {(provided, snapshot) => (
            <Container
              className={panelColorChange({
                isdraggingover: snapshot.isDraggingOver,
                isDraggable: snapshot.isDragging,
                isBacklog: true,
              })}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
              isdraggingover={snapshot.isDraggingOver}
              isDraggable={snapshot.isDragging}
              onClick={() => {
                const payload = {
                  unitId: task.unitId,
                  isEditable: task.isEditable,
                  isDeletable: task.isDeletable,
                  canModifyType: false,
                  memberTypeId: 11,
                  calledAs: "tanzeemOrgHabib",
                  isAssociated: task.isAssociatedWithMember,
                };

                const encrypted = encryptData(payload);

                const url = `member/membersdetails/${task.habibId}?data=${encrypted}`;
                window.open(url, "_blank");
              }}
            >
              {/* Top Section */}
              <div
                className="row align-items-start"
                style={{ minHeight: "80px", maxHeight: "80px" }}
              >
                {/* Left Side: Name, Unit, Associated Member */}
                <div className="col-lg-10">
                  <span
                    style={{ fontWeight: 600, fontSize: "16px" }}
                    className={isUrdu(task.name) ? "ur" : ""}
                  >
                    {task.name}
                  </span>
                  <br />
                  <span className="ur">{task.unitName}</span>
                  <br />
                  {task.associatedMember && (
                    <span className={isUrdu(task.associatedMember)}>
                      {applyClassToCharacters(
                        getStringFromJSX(
                          <GetLanguageString
                            props="associated_habib_of"
                            value={task.associatedMember}
                          />
                        ),
                        "ur"
                      )}
                    </span>
                  )}
                </div>

                {/* Right Side: Ellipsis Dropdown */}
                <div
                  className="col-lg-2 text-end"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "6px", // increase hit area
                    borderRadius: "50%", // optional: make it circular
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // 🔥 prevents parent onClick
                    // Your ellipsis logic here
                  }}
                >
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="span"
                      data-toggle="dropdown"
                      aria-expanded={false}
                      style={{
                        cursor: "pointer",
                        borderRadius: "60%",
                        padding: "10px",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f0f0f0")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      <FaEllipsisV color="#555" title="More Options" />
                    </DropdownToggle>

                    <DropdownMenu
                      end
                      container="body"
                      style={{ fontSize: "14px" }}
                    >
                      <DropdownItem onClick={() => onComment(task)}>
                        <FaRegComment className="me-2" color="#28a745" />
                        <GetLanguageString props="add_comment" />
                      </DropdownItem>
                      <DropdownItem onClick={() => viewComments(task)}>
                        <FaComments className="me-2" color="#007bff" />
                        <GetLanguageString props="view_comment" />
                      </DropdownItem>
                      {/* Submenu - hover based */}
                      <Dropdown
                        isOpen={subOpen}
                        toggle={() => setSubOpen(!subOpen)}
                        direction="end"
                        className="dropend"
                        onMouseEnter={() => setSubOpen(true)}
                        onMouseLeave={() => setSubOpen(false)}
                      >
                        <DropdownToggle
                          tag="div"
                          className="dropdown-item d-flex align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <FaExchangeAlt className="me-2" color="#e04c4cff" />

                          <GetLanguageString props="change_status" />
                        </DropdownToggle>

                        <DropdownMenu
                          style={{ fontSize: "16px" }}
                          className="show-on-top"
                        >
                          {progress
                            .filter((p) => p.progressName !== task.progressName) // exclude current
                            .map((prog, index) => (
                              <DropdownItem
                                className="ur"
                                key={index}
                                onClick={() =>
                                  onchangestatus({
                                    prog,
                                    task,
                                  })
                                }
                              >
                                {prog.progressName}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </Dropdown>
                      <DropdownItem onClick={() => onUpdateNisabClick(task)}>
                        <FaPencilAlt className="me-2" color="#af6607ad" />
                        <GetLanguageString props="update_dawati_nisab" />
                      </DropdownItem>

                      {task.isEditable ? (
                        <>
                          <DropdownItem
                            onClick={() => onUpdateAssociateMemberClick(task)}
                          >
                            <FaUserPlus className="me-2" color="#6fc2a1ff" />{" "}
                            {task.isAssociatedWithMember ? (
                              <GetLanguageString props="ahbab_update_associated_habib" />
                            ) : (
                              <GetLanguageString props="ahbab_associate_with_habib" />
                            )}
                          </DropdownItem>
                        </>
                      ) : null}
                      {(task.isAddedFromContactUsForm
                        ? CheckPermission("CanMoveTanzeemOrgAhbab")
                        : CheckPermission("CanMoveAhbab")) &&
                      task.unitId === 1 ? (
                        <DropdownItem
                          onClick={() => {
                            onMoveMemberClick(task, "Local");
                          }}
                        >
                          {<GetLanguageString props="ahbab_transfer_habib" />}
                        </DropdownItem>
                      ) : null}
                      {task.unitId !== 1 ? (
                        <div>
                          {CheckIsAdmin() ||
                          unitTypeName === "Markaz" ||
                          unitTypeName === "Zone" ||
                          unitTypeName === "ZoneOS" ? (
                            <DropdownItem
                              onClick={(e) => onMoveMemberClick(task, "admin")}
                            >
                              <FaPeopleArrows
                                className="me-2"
                                color="#be4444ff"
                              />
                              {
                                <GetLanguageString props="ahbab_transfer_habib" />
                              }
                            </DropdownItem>
                          ) : null}
                          {!CheckIsAdmin() &&
                          (task.isAddedFromContactUsForm
                            ? CheckPermission("CanMoveTanzeemOrgAhbab")
                            : CheckPermission("CanMoveAhbab")) &&
                          unitTypeName !== "Markaz" &&
                          unitTypeName !== "Zone" &&
                          unitTypeName !== "ZoneOS" ? (
                            <DropdownItem
                              onClick={(e) => onMoveMemberClick(task, "Local")}
                            >
                              <FaPeopleArrows
                                className="me-2"
                                color="#be4444ff"
                              />
                              <GetLanguageString props="unit_unitmember_move_member_localy" />
                            </DropdownItem>
                          ) : null}
                          {!CheckIsAdmin() &&
                          (task.isAddedFromContactUsForm
                            ? CheckPermission("CanRequestMoveTanzeemOrgAhbab")
                            : CheckPermission("CanRequestMoveAhbab")) &&
                          unitTypeName !== "Markaz" &&
                          unitTypeName !== "Zone" &&
                          unitTypeName !== "ZoneOS" ? (
                            <DropdownItem
                              onClick={(e) =>
                                onMoveMemberClick(task, "Outside")
                              }
                            >
                              <FaPeopleArrows
                                className="me-2"
                                color="#be4444ff"
                              />
                              <GetLanguageString props="unit_unitmember_move_members_other" />
                            </DropdownItem>
                          ) : null}
                        </div>
                      ) : null}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>

              <div
                style={{
                  cursor: "pointer",
                  marginTop: "10px",
                  minHeight: "105px",
                  maxHeight: "105px",
                }}
              >
                <div className="row">
                  {task.address && (
                    <p style={{ padding: "0px", margin: "0px" }}>
                      <FaMapMarkerAlt className="me-2" color="#607d8b  " />
                      <span
                        style={{
                          display: "inline-block",
                          maxWidth: "180px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          verticalAlign: "middle",
                          cursor: "pointer",
                          direction: isUrdu(task.address) ? "rtl" : "ltr",
                          textAlign: isUrdu(task.address) ? "right" : "left",
                        }}
                        className={isUrdu(task.address) ? "ur" : ""}
                        title={task.address}
                      >
                        {task.address}
                      </span>
                    </p>
                  )}
                  {task.contacts && (
                    <p style={{ padding: "0px", margin: "0px" }}>
                      <FaPhone className="me-2" color="#28a745" />
                      <a
                        href={`tel:${task.contacts}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {task.contacts}
                      </a>
                    </p>
                  )}
                  {task.email && (
                    <>
                      <p style={{ padding: "0px", margin: "0px" }}>
                        <FaEnvelope className="me-2" color="#4db6ac " />

                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "180px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                            cursor: "pointer",
                            direction: isUrdu(task.email) ? "rtl" : "ltr",
                            textAlign: isUrdu(task.email) ? "right" : "left",
                          }}
                          className={isUrdu(task.email) ? "ur" : ""}
                          title={task.email}
                        >
                          {task.email}
                        </span>
                      </p>
                    </>
                  )}

                  {task.memberEducation && (
                    <p style={{ padding: "0px", margin: "0px" }}>
                      <FaGraduationCap
                        className="me-2"
                        color="#0b0c0cff  "
                        size={17}
                      />
                      <span
                        className={isUrdu(task.memberEducation) ? "ur" : ""}
                      >
                        {task.memberEducation}
                      </span>
                    </p>
                  )}
                  {task.occupation && (
                    <p style={{ padding: "0px", margin: "0px" }}>
                      <FaBriefcase className="me-2" color="#664949ff  " />
                      <span className={isUrdu(task.occupation) ? "ur" : ""}>
                        {task.occupation}
                      </span>
                    </p>
                  )}
                </div>
              </div>
              {/* Bottom: Progress Bars */}
              <div
                style={{ minHeight: "96px", maxHeight: "96px" }}
                className="mt-3"
              >
                <Col md="12">
                  <span className="ur">دعوتی نصاب</span>
                  <div className={GetCustomStyles().stat_list_percent}>
                    ({task.readDawatiNisab}/{task.totalDawatiNisab}) {"  "}
                    {task.percentageDawatiNisab}%
                  </div>
                  <AhbabProgressBar
                    progress={task.percentageDawatiNisab}
                    color="#1AB394"
                    height={5}
                  />
                </Col>
                <Col md="12">
                  <span className="ur">دعوتی اجتماع</span>
                  <div className={GetCustomStyles().stat_list_percent}>
                    ({task.attendedDawatiIjtamaMeetings}/
                    {task.totalDawatiIjtamaMeetings}){"  "}
                    {task.percentageDawatiIjtamaMeetings}%
                  </div>
                  <AhbabProgressBar
                    progress={task.percentageDawatiIjtamaMeetings}
                    color="#1AB394"
                    height={5}
                  />
                </Col>
                <Col md="12">
                  <span className="ur">حلقہ قرانی</span>
                  <div className={GetCustomStyles().stat_list_percent}>
                    ({task.attendedHalqaQuraniMeetings}/
                    {task.totalHalqaQuraniMeetings}){"  "}
                    {task.percentageHalqaQuraniMeetings}%
                  </div>
                  <AhbabProgressBar
                    progress={task.percentageHalqaQuraniMeetings}
                    color="#1AB394"
                    height={5}
                  />
                </Col>
              </div>

              {provided.placeholder}
            </Container>
          )}
        </Draggable>
      </>
    </>
  );
};

export default HabibProgressCard;
